// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  email: __t.string(),
  name: __t.string(),
  avatar: __t.string(),
  lastSelectedOrganizationId: __t.option(__t.string()).name("last_selected_organization_id"),
  lastSignInAt: __t.option(__t.timestamp()).name("last_sign_in_at"),
  createdAt: __t.option(__t.timestamp()).name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
});
